<template>
  <div
    class="confirm-order-list-container"
    :class="{ 'mt-6': !cardMessage && !isConfirmedOrder }"
  >
    <div v-if="shoppingBagProducts.length">
      <h5 class="text-left">
        {{ isConfirmedOrder ? 'Overview' : ' Shopping Bag' }}
      </h5>
    </div>

    <ShoppingCart :disable-actions="isConfirmedOrder ? true : false">
      <!-- View for normal Data -->
      <template v-if="true">
        <!-- Single Recipient View -->
        <template v-if="showPrices && recipientType === 'single'">
          <tfoot>
            <tr v-for="i in 5" :key="i">
              <td
                v-for="j in 6"
                :key="j"
                :class="{
                  left: j === 4,
                  right: j !== 4,
                  'pt-2': i > 1,
                  bold: i === 4,
                  light: i === 4 && j === 4,
                  'total-box': i === 5 && j === 4,
                  'total-cost-box': i === 5 && j === 5
                }"
                :colspan="i === 4 && j === 4 ? 2 : 1"
              >
                {{ hanldeSingle(i, j) }}
              </td>
            </tr>
          </tfoot>
        </template>

        <!-- Multiple Recipient View -->
        <template v-if="showPrices && recipientType === 'multiple'">
          <tfoot>
            <tr v-for="i in 4" :key="i">
              <td
                v-for="j in 6"
                :key="j"
                :class="{
                  'left multiple-recipient': j === 4,
                  'right multiple-recipient': j === 5,
                  'pt-2': i >= 2,
                  'total-box': i === 4 && j === 4,
                  'total-cost-box': i === 4 && j === 5,
                  'right-multiple-recipient': i < 4 && j < 5,
                  'left-multiple-recipient': i < 4 && j === 5,
                  'multiple-recipient-light':
                    (i === 3 && j === 4) || (i === 3 && j === 5)
                }"
                :colspan="i < 5 && j === 5 ? 2 : 1"
              >
                {{ hanldeMultiple(i, j) }}
              </td>
            </tr>
          </tfoot>
          <tbody>
            <tr>
              <td colspan="6" class="multiple-recipient-info">
                <span class="content">
                  <img src="@/assets/info-warning.svg" />
                  <span class="text" v-if="!isConfirmedOrder">
                    Total price will include shipping and applicable taxes
                    calculated based on each recipient's shipping address and
                    shipping method.
                  </span>
                  <span class="text" v-else>
                    You can find the updated total when all items are shipped in
                    the View Details page of your order.
                    <button @click="handleViewOrder">View My Orders</button>
                  </span>
                </span>
              </td>
            </tr>
          </tbody>
        </template>
      </template>
    </ShoppingCart>

    <!-- Note for Tax here -->
    <div class="total-region" v-if="displayNote">
      <div class="note inter">
        The total price will include taxes, which are calculated based each
        recipient's shipping address.
      </div>
    </div>

    <!-- Confirmed Order Total display -->
    <!-- <div
      v-if="isConfirmedOrder && shoppingBagProducts.length"
      class="total-region"
    >
      <div class="total">
        <p>Total</p>
        <p>
          {{
            recipientType === 'single'
              ? this.total
              : formatCurrency(this.subTotal)
          }}
        </p>
      </div>
    </div> -->
  </div>
</template>

<script>
import Util from '@/mixins/Util'
import ShoppingCart from './ShoppingCart'
import { mapState } from 'vuex'

export default {
  name: 'ConfirmOrderItemsList',
  components: { ShoppingCart },
  mixins: [Util],

  props: {
    taxamount: {
      type: Number,
      default: 0
    },
    cardMessage: {
      type: String,
      default: ''
    },
    recipientType: {
      type: String,
      default: ''
    },
    shoppingBagProducts: {
      type: Array,
      default: () => []
    },
    currentOrderId: {
      type: String,
      default: ''
    }
  },

  data: () => ({
    currentUpdatedOrder: null
  }),

  beforeDestroy() {
    if (this.currentUpdatedOrder) {
      this.$store.commit('order/SET_ORDER', null)
    }
  },

  mounted() {
    if (this.isConfirmedOrder && this.order) {
      this.$store.dispatch('order/getIndividualOrder', this.order.id)
    }
  },

  computed: {
    ...mapState({
      selectedOption: state => state.recipient.orderRecipientList,
      selectedShippingRate: state => state.order.selectedShippingRate,
      order: state => state.order.order
    }),
    subTotal() {
      if (this.order && this.isConfirmedOrder) {
        return parseFloat(this.order.attributes.subtotal)
      }
      let total = 0
      if (!this.shoppingBagProducts) {
        return total
      } else {
        this.shoppingBagProducts.forEach(
          product =>
            (total +=
              parseInt(product.quantity) *
              parseFloat(
                product.type == 'product' || !product.type
                  ? product.selectedVariant.price || 0
                  : product.bundle_attributes.lowestPrice || 0
              ))
        )
      }
      return parseFloat(total)
    },
    total() {
      if (this.order && this.isConfirmedOrder) {
        return parseFloat(this.order.attributes.total)
      }
      return parseFloat(
        parseFloat(this.subTotal || 0) +
          parseFloat(this.taxAmount || 0) +
          parseFloat(
            this.selectedShippingRate ? this.selectedShippingRate.price || 0 : 0
          )
      )
    },
    isConfirmedOrder() {
      return this.$route.name === 'ConfirmedOrder'
    },
    taxAmount() {
      if (this.order && this.isConfirmedOrder) {
        return parseFloat(this.order.attributes.taxAmount)
      }
      return parseFloat(this.taxamount || 0)
    },
    shippingFee() {
      if (this.order && this.isConfirmedOrder) {
        return parseFloat(this.order.attributes.shippingFee)
      }
      return parseFloat(
        this.selectedShippingRate ? this.selectedShippingRate.price || 0 : 0
      )
    },
    displayNote() {
      return (
        this.showPrices &&
        this.recipientType === 'multiple' &&
        !this.isConfirmedOrder
      )
    },
    showPrices() {
      return this.$store.getters['team/showPrices']
    }
  },

  methods: {
    hanldeSingle(i, j) {
      if (j === 4) {
        switch (i) {
          case 1:
            return 'Subtotal'
          case 2:
            return 'Taxes'
          case 3:
            return 'Shipping'
          case 4:
            return this.selectedShippingRate
              ? `(${this.selectedShippingRate.service_type || ''})`
              : ''
          case 5:
            return 'Total'
          default:
            return ''
        }
      } else if (j === 5) {
        switch (i) {
          case 1:
            return this.formatCurrency(this.subTotal)
          case 2:
            return this.formatCurrency(this.taxAmount)
          case 3:
            return this.formatCurrency(this.shippingFee)
          case 4:
            return ''
          case 5:
            return this.formatCurrency(this.total)
          default:
            return ''
        }
      }
    },

    hanldeMultiple(i, j) {
      if (j === 4) {
        switch (i) {
          case 1:
            return 'Estimated no. of orders'
          case 2:
            return 'Subtotal'
          case 3:
            return 'Shipping'
          case 4:
            return 'Total'
          default:
            return ''
        }
      } else if (j === 5) {
        switch (i) {
          case 1:
            return this.selectedOption.totalRecords || 0
          case 2:
            return this.formatCurrency(this.subTotal)
          case 3:
            return 'TDB'
          case 4:
            return this.formatCurrency(this.total)
          default:
            return ''
        }
      }
    },
    async increaseItem(productId) {
      if (this.currentUpdatedOrder) return

      this.currentUpdatedOrder = productId
      await this.$store.dispatch('order/updateOrderCartItemQty', {
        productId: parseInt(productId),
        action: 'increase'
      })

      this.currentUpdatedOrder = null
    },

    async removeItem(productId) {
      if (this.currentUpdatedOrder) return

      this.currentUpdatedOrder = productId
      let shouldRedirect = this.items.length < 2
      await this.$store.dispatch('order/removeItemFromOrder', productId)
      if (shouldRedirect) {
        await this.$router.push({ name: 'ShoppingBag' })
      }
      this.currentUpdatedOrder = null
    },

    async decreaseItem(productId) {
      if (this.currentUpdatedOrder) return

      this.currentUpdatedOrder = productId
      await this.$store.dispatch('order/updateOrderCartItemQty', {
        productId: parseInt(productId),
        action: 'decrease'
      })
      this.currentUpdatedOrder = null
    },
    showSizeIf(product) {
      if (product.size !== '-' && product.size !== undefined) {
        return true
      }

      return false
    },
    displaySelection(variant) {
      if (variant) {
        let selections = []
        if (variant.type) selections.push(variant.type)
        if (variant.color) selections.push(variant.color)
        if (variant.size) selections.push(variant.size)

        return selections.map(selection => selection).join('\n')
      }
      return ''
    },
    handleViewOrder() {
      this.$router.push(`/orders/${this.currentOrderId}`)
    }
  }
}
</script>

<style scoped lang="scss">
@import '@/global.scss';

.confirm-order-list-container {
  margin-top: 2rem;

  &.mt-6 {
    margin-top: 6rem;
  }
}

.class-updating-cart {
  opacity: 0.3;
  cursor: not-allowed;
}

.pt-2 {
  padding-top: 1.25rem;
}

.bold {
  font-weight: bold;
}

.light {
  border-bottom: none;
  padding-top: 0px !important;
  height: max-content !important;
  font-weight: 400 !important;
  font-size: 0.68rem;
  padding-bottom: 1.25rem;
}

.left {
  text-align: left;
  padding-left: 6.4rem !important;
}

.right {
  text-align: left;
  padding-left: 4px;

  &.multiple-recipient {
    padding-right: 0rem !important;
    text-align: left;
  }
  padding-left: 0.9rem;
}

.right-multiple-recipient {
  text-align: right !important;
  padding-left: 0 !important;
  padding-bottom: 0.5rem !important;
}

.left-multiple-recipient {
  text-align: left !important;
  padding-left: 1.7rem !important;
  padding-bottom: 0.5rem !important;
}

@media (max-width: 998px) {
  .left {
    padding-left: 2rem !important;
  }
  .right {
    padding-left: 0.4rem !important;
  }
  .right-multiple-recipient {
    text-align: right !important;
    padding-left: 0 !important;
    padding-bottom: 0.5rem !important;
  }
  .left-multiple-recipient {
    text-align: left !important;
    padding-left: 1.7rem !important;
    padding-bottom: 0.5rem !important;
  }
}

.total-box {
  background-color: #dfdad2;
  margin-left: 6.4rem !important;
  display: block;
  padding-left: 10px !important;
  text-align: right !important;
  padding-top: 0px !important;
  padding: 10px !important;
  padding-right: 5px !important;
  font-weight: 700;
  font-size: 0.813rem;

  &.left {
    text-align: right !important;
  }
}
.total-cost-box {
  background-color: #dfdad2;
  padding-left: 10px !important;
  text-align: left !important;
  padding-top: 0px !important;
  margin-top: 1.25rem;
  padding: 10px !important;
  font-weight: 700;
  padding-left: 15px !important;
  font-size: 0.813rem;
}

.multiple-recipient {
  &.total-box {
    padding-left: 1.2rem !important;
    padding-right: 0.1rem !important;
  }
}
.multiple-recipient {
  &.total-cost-box {
    padding-left: 2rem !important;
  }
}

@media (min-width: 1569px) {
  .total-box {
    text-align: left !important;
  }
}

@media (min-width: 1400px) {
  .left {
    position: relative;
    left: 10px;
  }
  .total-box {
    padding-right: 15px !important;
  }
  .multiple-recipient {
    &.total-box {
      padding-left: 0rem !important;
      padding-right: 0.1rem !important;
    }
  }
}

.total-region {
  font-family: $inter;
  margin-top: 1rem;
  display: flex;
  justify-content: end;
}

.note {
  background: $dark-gray;
  padding: 1rem;
  text-align: left;
  width: 315px;
  color: #25282a;
  font-size: 0.688rem;
  border-radius: 10px;
}

.total {
  display: flex;
  margin: 2rem 0;
  text-align: left;
  width: 25%;

  p {
    font-weight: 700;
    font-size: 0.875rem;

    &:nth-child(2) {
      margin-left: 3.75rem;
    }
  }
}

.multiple-recipient-light {
  padding-bottom: 1.25rem !important;
}

.multiple-recipient-info {
  border-bottom: none !important;
  padding-top: 1rem;
  padding-bottom: 1rem;
  width: 100%;
  gap: 0.5rem;

  .content {
    display: flex;
    align-items: flex-start;
    gap: 0.5rem;

    img {
      width: 14px;
      height: 14px;
    }

    .text {
      font-weight: 400;
      margin: 0;
      position: relative;
      top: -3px;

      button {
        font-weight: 700;
        font-family: $inter;
        text-decoration: none;
        color: #232220;

        &:hover {
          color: #232220;
          opacity: 0.8;
        }
      }
    }
  }
}
</style>
